import React from "react";

const AboutProgressBar = ({ done, title, arrowup }) => {
  return (
    <div className="col-md-6">
      <div className="item bord-thin-top pt-30 d-flex align-items-end">
        <div>
          <h3 className="fw-300 mb-10">{done}</h3>
          <h6 className="p-color sub-title fz-11">{title}</h6>
          <br></br>
        </div>
        <div className="ml-auto">
          <div className="icon-img-40">
            <img
              style={
                arrowup > 0
                  ? {
                      transform: "rotate(270deg)",
                    }
                  : {}
              }
              src="/assets/imgs/arw0.png"
              alt=""
            />
          </div>
        </div>
      </div>
    </div>
  );
};

function About() {
  return (
    <section className="about-author section-padding">
      <div className="container with-pad">
        <div className="row lg-marg">
          <div className="col-lg-5 valign">
            <div className="profile-img">
              <div className="img">
                <img src="/assets/imgs/header/p2-new.png" alt="" />
              </div>
              <span className="icon">
                <img src="/assets/imgs/resume/s1.png" alt="" />
              </span>
              <span className="icon">
                <img src="/assets/imgs/resume/s2.png" alt="" />
              </span>
              <span className="icon">
                <img src="/assets/imgs/resume/s3.png" alt="" />
              </span>
              <span className="icon">
                <img src="/assets/imgs/resume/s4.png" alt="" />
              </span>
            </div>
          </div>
          <div className="col-lg-7 valign">
            <div className="cont">
              <h6 className="sub-title main-color mb-30">About Me</h6>
              <div className="text">
                <h4 className="mb-30 fz-24">
                  I&apos;m{" "}
                  <span className="fw-200">a UX Designer&nbsp;</span>
                  passionate about turning complex problems into simple,
                  inclusive, and engaging digital experiences.
                </h4>
                <p className="fz-15">
                  I specialize in design systems, accessibility, and
                  research-driven design, creating products that are not only
                  intuitive but also deliver measurable business impact. My work
                  spans SaaS, e-commerce, AI, and cloud, where I’ve led
                  end-to-end projects—driving clarity, improving user
                  satisfaction, and reducing friction through thoughtful,
                  data-backed design.
                </p>
                <br></br>
                <p className="fz-15">
                  With a strong foundation in Human-Centered Interaction Design,
                  I combine usability principles, accessibility standards, and
                  cognitive psychology to craft digital solutions that are
                  scalable, impactful, and human-first.
                </p>
                <br></br>

                <div className="numbers">
                  <div className="row lg-marg">
                    <AboutProgressBar
                      done="+15%"
                      title="Customer Satisfaction (CSAT) Improvement through journey mapping & prototyping"
                      arrowup
                    />
                    <AboutProgressBar
                      done="+18%"
                      title="Increase in Self-Service Engagement via chatbot and help-center design"
                      arrowup
                    />
                    <AboutProgressBar
                      done="-22%"
                      title="Friction Reduced in Task Flows through usability testing & research synthesis"
                    />
                    <AboutProgressBar
                      done="+25%"
                      title="Faster Design Approvals with high-fidelity prototypes & walkthroughs"
                      arrowup
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default About;
